class Sliders {

    static onSliderScroll($trigger, direction){
        var step = 0;
        var	$sliderInner = $trigger.parents('.slider').find('.slider-inner');
        var	$sliderContainer = $sliderInner.find('.tiles');
        var	currentSlide = parseInt($sliderInner.attr('data-slide-index'));
        var	totalSlides = parseInt($sliderInner.attr('data-slides-count'));
        var	sliderWidth = $sliderInner.width();

        if(direction === 'right'){
            if(currentSlide < totalSlides){
                step = currentSlide * sliderWidth;
                $sliderInner.attr('data-slide-index', currentSlide+1);
            } else{
                $sliderInner.attr('data-slide-index', '1');
            }
        } else{
            if(currentSlide === 1){
                step = (totalSlides-1) * sliderWidth;
                $sliderInner.attr('data-slide-index', totalSlides);
            } else{
                step = sliderWidth * (currentSlide-2);
                $sliderInner.attr('data-slide-index', currentSlide-1);
            }
        }
        $sliderContainer.css({
            '-webkit-transform' : 'translateX(-'+step+'px)',
            '-moz-transform': 'translateX(-'+ step +'px)',
            '-ms-transform': 'translateX(-'+ step +'px)',
            '-o-transform': 'translateX(-'+step+'px)',
            'transform' : 'translateX(-' + step + 'px)'
        });
    }

    static initEvents() {
        jQuery(document.body).on('click', '[data-slider-scroll]', function () {
            Sliders.onSliderScroll(jQuery(this), jQuery(this).attr('data-slider-scroll'));
        });
    }
    static initModule() {
        Sliders.initEvents();
    }
}

export default Sliders;